module.exports = "/_next/static/images/usEnergySolutions-03377b96f8a507e5ab531f339bb822b8.png.webp";